module.exports = __webpack_public_path__ + "static/media/83.6f7fb729.png";